<script>
  import { onMount } from "svelte";
  import { translator, userStore } from "../../store/index";
  import {
    deleteProperty,
    getProperties,
  } from "../../helpers/apiHelpers/index.svelte";
  import { DataTable } from "../../components/index.svelte";
  import { navigate } from "svelte-navigator";
  import { toast, checkIfAdmin } from "../../helpers/utils.svelte";
  import PropertyDeleteModal from "./PropertyDeleteModal.svelte";

  let dataSource = null;
  let openDeleteModal;
  let propertyToDelete;

  function onView(row) {
    navigate(window.location.pathname + "/properties/" + row.id);
  }

  function onEdit(row) {
    navigate(window.location.pathname + "/properties/" + row.id + "/edit");
  }

  function onDelete(row) {
    propertyToDelete = row;
    openDeleteModal();
  }

  function onAdd() {
    navigate(window.location.pathname + "/properties/new");
  }

  async function onDeleteClick(propertyID) {
    try {
      await deleteProperty(propertyID);
      toast.success(
        translator("Başarılı"),
        translator('"__PROPERTYNAME__" bilgileri silindi', {
          __PROPERTYNAME__: `${propertyToDelete.name}`,
        })
      );
      dataSource = await getProperties();
      openDeleteModal();
    } catch (err) {
      console.log(err);
      toast.error(
        translator("Hata"),
        err.getResponseMessage ? err.getResponseMessage() : err.message
      );
    }
  }
  let isAdmin = checkIfAdmin($userStore?.user?.user_type);
  onMount(async () => {
    try {
      dataSource = await getProperties();
    } catch (err) {
      toast.error(translator("Hata"), translator(err.getResponseMessage()));
    }
  });
</script>

<div class="row">
  <DataTable
    title={translator("Ev Listesi")}
    eventHandlers={{
      onView,
      onEdit: isAdmin ? onEdit : null,
      onDelete: isAdmin ? onDelete : null,
    }}
    columns={[
      { data: "name", title: translator("Ev İsmi") },
      { data: "owner.fullname", title: translator("Ev Sahibi") },
      { data: "city_name", title: translator("Şehir") },
      {
        data: "is_active",
        title: translator("Durumu"),
        render: (text) => {
          if (text === 1) {
            return translator("Aktif");
          }
          return translator("Pasif");
        },
      },
    ]}
    onAddClick={isAdmin ? onAdd : null}
    addText={isAdmin ? translator("Yeni Ev Oluştur") : null}
    bind:dataSource
  />
</div>

<PropertyDeleteModal
  bind:openModal={openDeleteModal}
  {propertyToDelete}
  {onDeleteClick}
/>
